import React, { useState } from "react";
import { FlexBox, Typography, Box } from "@vp/swan";
import support from "../care.svg";
import useScreenClass from "../useScreenClass";
import "./ContactFooter.scss";

interface ContactFooterProps {
  supportPhoneNumber: string;
}

const ContactFooter = (props: ContactFooterProps) => {
  const { supportPhoneNumber } = props;
  const { isMobile, isSmallScreen } = useScreenClass();
  const [isLogoLoaded, setIsLogoLoaded] = useState(false);
  if (isMobile || isSmallScreen) {
    return <></>;
  }
  return (

      <Box className="contact-container">

          <FlexBox
            justifyContent="flex-end"
            flexWrap="nowrap"
            flexDirection="row"
            className="contact-footer"
          >
            <Box className="boundary">
              <img
                onLoad={(e) => {
                  setIsLogoLoaded(true);
                }}
                className={isLogoLoaded ? "supportLogo" : "supportLogo-hide"}
                data-testid="contact-logo"
                src={support}
                alt="contact-logo"
              />
              <Typography marginRight={5} marginLeft={4} mt="2" fontWeight="bold" > {supportPhoneNumber}</Typography>
              </Box>
          </FlexBox>
      </Box>
  );
};
export default ContactFooter;
